import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Carousel from 'react-bootstrap/Carousel';
import './Slider.css';

const Slider = (props) => {
    const { list = [] } = props;

    return (
        <section className='slider pt-1'>
            <Container className='p-0'>
                <Row>
                    <Carousel indicators={false}>
                        {list.map((item, index) => {
                            // Map backend fields to what Slider expects
                            const title = item.posttitle || item.title || "No Title";
                            const image = item.imagepath || item.image || "";
                            const post_url = item.post_url || item.posturltitle || "#";
                            const categoryurl = item.categoryurl || "";   // fallback if needed

                            return (
                                <Carousel.Item interval={3000} key={index}>
                                    <Link to={post_url}>
                                        <Carousel.Caption>
                                            <h3>{title}</h3>
                                        </Carousel.Caption>
                                        {image && (
                                            <img 
                                                src={image} 
                                                alt={title} 
                                                loading="lazy" 
                                               onError={(e) => {
                                                    e.target.onerror = null; // 🛑 stop loop
                                                    e.target.src = "/placeholder-image.jpg";
                                                }}
                                            />
                                        )}
                                    </Link>
                                </Carousel.Item>
                            );
                        })}
                    </Carousel>
                </Row>
            </Container>
        </section>
    );
};

export default Slider;